import { useMemo } from 'react';
import type { SalesMetricType } from '@api';
import type { EChartsCoreOption } from 'echarts/core';
import { useTranslation } from 'react-i18next';
import {
  getGridOptions,
  getSeriesOptions,
  getTooltipOptions,
  getXAxisOptions,
  getYAxisOptions,
} from './helpers';

type UseSalesTimelineChartOptionThemeColorsType = {
  lineColor: string;
  barColor: string;
  selectedLineColor: string;
  selectedBarColor: string;
};

type UseSalesTimelineChartOptionArgsType = {
  salesTimeline: SalesMetricType[];
  themeColors: UseSalesTimelineChartOptionThemeColorsType;
  selectedDate1: string | null;
  selectedDate2: string | null;
};

export const useSalesTimelineChartOption = ({
  salesTimeline,
  themeColors,
  selectedDate1,
  selectedDate2,
}: UseSalesTimelineChartOptionArgsType): EChartsCoreOption => {
  const { t } = useTranslation('ticketSales');

  return useMemo(
    () => ({
      animation: false,
      tooltip: getTooltipOptions({ salesTimeline, t }),
      grid: getGridOptions(),
      xAxis: getXAxisOptions({ salesTimeline }),
      yAxis: getYAxisOptions(),
      series: getSeriesOptions({
        salesTimeline,
        themeColors,
        selectedDate1,
        selectedDate2,
      }),
    }),
    [salesTimeline, selectedDate1, selectedDate2, themeColors, t]
  );
};
